import { PendingTimesheet } from 'features/pending-timesheets/models/pending-timesheets.model';

const fakeTimesheets: PendingTimesheet[] = [
    {
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fa',
        travelerFirstName: 'Steven',
        travelerLastName: 'Elwood',
        unitName: 'Cath Lab',
        regularHours: 19.0,
        onCallHours: 1.0,
        callbackHours: 2.0,
        chargeHours: 3.0,
        totalHours: 19.0,
        payPeriodStart: '2020-12-01',
        payPeriodEnd: '2020-12-14',
        onlineApprovalDate: null,
        timesheetComment: 'This is a timesheet comment - column Comment',
        supervisorComment: 'This is a supervisor comment - column supervisorComment',
    },
    {
        timesheetId: '3e6dd10b-d598-4e1f-be02-9656702910db',
        travelerFirstName: 'Wayne',
        travelerLastName: 'Needham',
        unitName: 'ICU',
        regularHours: 1.8,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 1.8,
        payPeriodStart: '2020-12-01',
        payPeriodEnd: '2020-12-14',
        onlineApprovalDate: null,
    },
    {
        timesheetId: '3e6dd10b-d598-4e1f-be02-9656702910dc',
        travelerFirstName: 'Cathy',
        travelerLastName: 'McCabe',
        unitName: 'Cath Lab',
        regularHours: 1.8,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 1.8,
        payPeriodStart: '2020-12-01',
        payPeriodEnd: '2020-12-14',
        onlineApprovalDate: null,
    },
    {
        timesheetId: 'ada8a376-755a-4781-86a2-de5055178893',
        travelerFirstName: 'Jessie',
        travelerLastName: 'Blackman',
        unitName: 'ER',
        regularHours: 23.0,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 23.0,
        payPeriodStart: '2020-11-17',
        payPeriodEnd: '2020-11-30',
        onlineApprovalDate: null,
    },
    {
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fb',
        travelerFirstName: 'Brandon',
        travelerLastName: 'Rinck',
        unitName: 'ICU',
        regularHours: 19.0,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 19.0,
        payPeriodStart: '2020-11-17',
        payPeriodEnd: '2020-11-30',
        onlineApprovalDate: null,
    },
    {
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7fc',
        travelerFirstName: 'Cari',
        travelerLastName: 'Snyder',
        unitName: 'ER',
        regularHours: 7.0,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 7.0,
        onlineApprovalDate: new Date('2020-09-22T00:00:00'),
        payPeriodStart: '2020-11-03',
        payPeriodEnd: '2020-11-16',
        timesheetComment: 'This is a timesheet comment - column Comment',
    },
    {
        timesheetId: '24372118-6cf0-40b5-95c5-5bc5c030a7f3',
        travelerFirstName: 'Carianne',
        travelerLastName: 'Smith',
        unitName: 'ER',
        regularHours: 7.0,
        onCallHours: 0.0,
        callbackHours: 0.0,
        chargeHours: 0.0,
        totalHours: 7.0,
        payPeriodStart: '2020-11-03',
        payPeriodEnd: '2020-11-16',
        onlineApprovalDate: null,
    },
];

export { fakeTimesheets };
